import '../Stylesheets/Parallax.css'; // Import your stylesheet

export default function Parallax() {
  return (
    <div className="parallax"></div> // Standalone parallax section
  );
}
